// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

export const PanelDuplicateMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item onSelect={onSelect}>
      <Icon name="copy" />
      Duplicate panel
    </DropdownMenu.Item>
  );
};
